import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-jason-blog/src/templates/page.js";
import { OptIn, OptInNotice } from '$components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`If you like my content and want to read more of it, then you’ve come to the right place, my friend: `}<strong parentName="p">{`I send out a newsletter whenever I write something new.`}</strong></p>
    <p>{`In addition to letting you know when I’ve published new content on my site, `}<strong parentName="p">{`I occasionally send out shorter thoughts and ideas `}<em parentName="strong">{`only to subscribers`}</em>{`. If you’re big on exclusive content, this might be fun for you.`}</strong></p>
    <OptIn button="Join Now" group="DEFAULT" source="/newsletter/" mdxType="OptIn" />
    <OptInNotice mdxType="OptInNotice">
  Note: I will never share your email or spam you with nonsense.
  Because I’m not a dick.
    </OptInNotice>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      